import Icon from '@/components/public/ui/Icon';

interface SearchBarProps {
  placeholder?: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
  ariaLabel?: string;
}

// Light search input — matches the canonical text-input styling.
export default function SearchBar({
  placeholder = 'Pesquisar...',
  value,
  onChange,
  className = '',
  ariaLabel,
}: SearchBarProps) {
  return (
    <div
      className={`border-line bg-surface focus-within:border-primary flex h-11 items-center gap-3 rounded-md border px-4 transition-all duration-200 focus-within:shadow-[0_0_0_3px_rgb(from_var(--color-primary)_r_g_b/0.12)] ${className}`}
    >
      <Icon name="search" size="sm" className="text-on-surface-light shrink-0" />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        aria-label={ariaLabel ?? placeholder}
        className="text-on-surface placeholder:text-on-surface-light/60 flex-1 border-none bg-transparent text-sm outline-none"
      />
    </div>
  );
}
